import React from 'react';
import {
  Route,
  Redirect,
  Switch,
  useRouteMatch,

} from 'react-router-dom';

import pages, { pagesConfig } from '../../config/pages';
import useToolsNavigation from '../../hooks/useToolsNavigation';

import CoachToolsRoute from '../ToolsRoute';
import routes from './routes';

const ManageClientsRoutes = () => {
  const { path } = useRouteMatch();
  const { pathname } = useToolsNavigation();

  return (
    <Switch>
      {routes.map(({
        pageId,
        path: routePath,
        component,
      }) => (
        <CoachToolsRoute
          key={pageId}
          pageId={pageId}
          path={`${path}/${routePath}`}
          component={component}
        />
      ))}

      <Route exact path={`${path}`}>
        <Redirect to={{ pathname: `${pathname}/${pagesConfig[pages.MANAGE_CLIENTS].path}` }} />
      </Route>
    </Switch>
  );
};

export default ManageClientsRoutes;
